import { useContext } from 'react';
import { UserContext } from '../contexts/userContext';

export function useUser() {
    const context = useContext(UserContext);
    return context;
}